module.exports = __webpack_public_path__ + "img/icon-white-43.b9c7ef5d.svg";